import { render, staticRenderFns } from "./qa_item.vue?vue&type=template&id=34520d39&scoped=true&"
import script from "./qa_item.vue?vue&type=script&lang=js&"
export * from "./qa_item.vue?vue&type=script&lang=js&"
import style0 from "./qa_item.vue?vue&type=style&index=0&id=34520d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34520d39",
  null
  
)

export default component.exports